import { IonCard } from '@ionic/react';
import { ReactNode } from 'react';

import styles from '@components/labels/Tag.module.css';
import Icon from '@components/text/Icon';
import TagText from '@components/typography/TagText';
import { Colors } from '@utils/colorUtils';
import { IconName } from '@utils/iconUtils';

export type TagProps = {
  children?: ReactNode;
  color: Colors;
  icon?: IconName;
  size?: 'large';
  spacing?: boolean;
  text?: string;
  textColor?: Colors;
};

const Tag = ({ children, color, icon, size, spacing = false, text, textColor }: TagProps) => {
  const colorForText = textColor ? textColor : color === 'gray-50' ? 'black' : 'white';

  const wrapperStyles = [styles.tag];

  if (size === 'large') {
    wrapperStyles.push(styles.largeTag);
  }

  if (spacing) {
    wrapperStyles.push(styles.spacing);
  }

  if (icon) {
    wrapperStyles.push(styles.withIcon);
  }

  return (
    <IonCard className={wrapperStyles.join(' ')} color={color}>
      {icon && (
        <span className={styles.icon}>
          <Icon color={colorForText} icon={icon} />
        </span>
      )}
      <TagText color={colorForText}>{children ?? text}</TagText>
    </IonCard>
  );
};

export default Tag;
